(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cotoala-testimonial-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.cotoala-testimonials';

    const setup = (section) => {
      if (section.dataset.interactionsReady === 'true') return;
      section.dataset.interactionsReady = 'true';

      const dialog = section.querySelector('[data-testimonial-dialog]');
      const dialogImage = section.querySelector('[data-testimonial-dialog-image]');
      const dialogClose = section.querySelector('[data-testimonial-dialog-close]');

      if (dialog && dialogImage && dialogClose) {
        section.querySelectorAll('[data-testimonial-image]').forEach((imageButton) => {
          imageButton.addEventListener('click', () => {
            dialogImage.src = imageButton.dataset.imageUrl || '';
            dialogImage.alt = imageButton.dataset.imageAlt || '';
            dialog.showModal();
          });
        });

        dialogClose.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }

      section.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
        const viewport = carousel.querySelector('.cotoala-testimonials__viewport');
        const pages = [...carousel.querySelectorAll('[data-testimonial-page]')];
        const previousButton = carousel.querySelector('[data-testimonial-previous]');
        const nextButton = carousel.querySelector('[data-testimonial-next]');
        const pageCount = carousel.classList.contains('cotoala-testimonials__carousel--desktop')
          ? section.querySelector('[data-testimonial-current-page]')
          : null;
        if (!viewport || pages.length < 2 || !previousButton || !nextButton) return;

        const shouldLoop = section.dataset.loopPages === 'true';
        let currentPage = 0;
        let scrollFrame;

        const setCurrentPage = () => {
          const nearestPage = pages.reduce((closestIndex, page, index) => {
            const closestDistance = Math.abs(pages[closestIndex].offsetLeft - viewport.scrollLeft);
            const pageDistance = Math.abs(page.offsetLeft - viewport.scrollLeft);
            return pageDistance < closestDistance ? index : closestIndex;
          }, 0);

          currentPage = nearestPage;
          if (pageCount) pageCount.textContent = String(currentPage + 1);
          previousButton.disabled = !shouldLoop && currentPage === 0;
          nextButton.disabled = !shouldLoop && currentPage === pages.length - 1;
        };

        const goToPage = (pageIndex) => {
          viewport.scrollTo({
            left: pages[pageIndex].offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        nextButton.addEventListener('click', () => {
          const nextPage = currentPage + 1;
          goToPage(nextPage < pages.length ? nextPage : 0);
        });

        previousButton.addEventListener('click', () => {
          const previousPage = currentPage - 1;
          goToPage(previousPage >= 0 ? previousPage : pages.length - 1);
        });

        viewport.addEventListener('scroll', () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(setCurrentPage);
        }, { passive: true });

        setCurrentPage();
      });
    };

    document.querySelectorAll(selector).forEach(setup);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.closest(selector);
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
